import moment from "moment";

import { useNavigate } from "react-router-dom";
import { useContext, useEffect } from "react";
import { useState } from "react";
import {
  facebookIcon,
  appStoreIcon,
  googlePlayIcon,
  instagramIcon,
  linkedinIcon,
  youtubeIcon,
  twitterIcon,
  visa,
  mastercard,
  applepay,
  samsungpay,
  googlepay,
  tabby,
  tamara,
  facebook_new,
  twitter_new,
  instagram_new,
  linkedin_new,
  youtube_new,
  googlePlayNew,
  appStoreNew
  
} from "../../assets/footer";
import GooglePlay from "../../assets/tryingGoogle.svg";
import playStore from '../../assets/footer/google-play-store.svg'
import "./footer.scss";
import axios from "axios";
import General from '../../stores/GeneralStore'
import { observer } from "mobx-react";
import constants from "../../../src/utils/constants";

const Footer = () => {
  const [updatedDate, setUpdatedDate] = useState();
  const navigate = useNavigate();

  const [isLargeScreen, setIsLargeScreen] = useState(false);

  useEffect(() => {
    function handleResize() {
      setIsLargeScreen(window.innerWidth > 991);
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    getFormattedDate();
  }, []);


  // const modifiedDate = moment(updatedDate).format("DD-MMMM-YYYY");
  function getFormattedDate() {
    const currentLanguage=localStorage.getItem('settingUplanguage');
    const API_ENDPOINT = constants.URL.BASE_URL_1;
    
    const headers = {
      'Content-Type': 'application/json',
      'currentLanguage': 'en-US',//ar,hi,en-US
      'Accept-Language':'en-US',
    }

    axios.get(`${API_ENDPOINT}api/ASPCL/Web/GetLastUpdatedDate`, { headers })
      .then(response => {
        if (response?.data) {
          setUpdatedDate(response?.data?.data);
        }

      })
      .catch(error => {
      });

  }
  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;
  function getDynamicYear() {
    const currentYear = new Date().getFullYear();
    return currentYear;
  }
  const monthsHi= [
    "जनवरी",
    "फरवरी",
    "मार्च",
    "अप्रैल",
    "मई",
    "जून",
    "जुलाई",
    "अगस्त",
    "सितंबर",
    "अक्टूबर",
    "नवंबर",
    "दिसंबर"
  ];
 const monthsAR= [
    "يناير",
    "فبراير",
    "مارس",
    "أبريل",
    "مايو",
    "يونيو",
    "يوليو",
    "أغسطس",
    "سبتمبر",
    "أكتوبر",
    "نوفمبر",
    "ديسمبر"
  ];
  const monthsEn= [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ];
  const getMonthName = (monthIndex, selectedLanguage) => {
    switch (selectedLanguage) {
      case "ARA":
        return monthsAR[monthIndex];
      case "HIN":
        return monthsHi[monthIndex];
      default:
        return monthsEn[monthIndex];
    }
  };
  const formatDate = (dateStr, selectedLanguage) => {
    const dateObj = moment(dateStr);
    const day = dateObj.format("D");
    const month = dateObj.format("MM");
    const year = dateObj.format("YYYY");
    const monthName = getMonthName(parseInt(month, 10) - 1, selectedLanguage);

    // console.log(selectedLanguage,dateObj)
  
    switch (selectedLanguage) {
      case "ARA":
        return `${day} ${monthName} ${year}`;
      case "HIN":
        return `${day} ${monthName} ${year}`;
      default:
        return `${day} ${dateObj.format("MMM")} ${year}`; // Use 'MMM' for abbreviated month name in English
    }
  };
  // console.log(updatedDate);
  const modifiedDate = updatedDate ? formatDate(updatedDate, General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode ) : null;

  return (
    <div className="footer-wrapper" style={{
      color: contrast?.contrastColor ? contrast?.contrastColor : '',
      backgroundColor: contrast?.contrastBackground ? contrast?.contrastBackground : ColorAss ? ColorAss : '#101E8E',
      width:'100%'

    }}>
      <div  style={{direction:General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode =="ARA"?'rtl':""}}  className="footer-content" >
        <div className="links">
          <ul>
            <li onClick={() => window.open("https://www.ajmansewerage.ae/home/ourservices/faq")}>{General?.codeLabels["cm_faqs"]?.label !== undefined ? General?.codeLabels["cm_faqs"]?.label : "FAQs"}</li>
            <li className="" onClick={() => window.open("https://www.ajmansewerage.ae/home/disclaimer")}>
              {General?.codeLabels["cm_disclaimer"]?.label !== undefined ? General?.codeLabels["cm_disclaimer"]?.label : "Disclaimer"}
            </li>
            <li className="" onClick={() => window.open("https://www.ajmansewerage.ae/home/privacypolicy")}>

              {General?.codeLabels["cm_website_policy"]?.label !== undefined ? General?.codeLabels["cm_website_policy"]?.label : "Website Policy"}
            </li>
            <li className=""
              onClick={() =>
                window.open("https://www.ajmansewerage.ae/home/ourservices/customerhappinesscharter")
              }
            >
              {General?.codeLabels["cm_customercharterfooter"]?.label !== undefined ? General?.codeLabels["cm_customercharterfooter"]?.label : "Happiness Charter"}
            </li>
          </ul>
          <ul>
            <li
              onClick={() =>
                window.open("https://www.ajmansewerage.ae/home/ourservices/customerhappinesscenter")
              }
            >
              {General?.codeLabels["cm_mob_location"]?.label !== undefined ? General?.codeLabels["cm_mob_location"]?.label : "Locations"}
            </li>
            <li className="" onClick={() => window.open('https://www.ajmansewerage.ae/home/ASPCL-Careers')}>
              {General?.codeLabels["cm_aspcl_careers"]?.label !== undefined ? General?.codeLabels["cm_aspcl_careers"]?.label : "ASPCL Careers"}
            </li>
            <li className="" onClick={() => window.open('https://www.ajmansewerage.ae/home/school-trip')}>
              {General?.codeLabels["cm_request_visit_for_school_trip"]?.label !== undefined ? General?.codeLabels["cm_request_visit_for_school_trip"]?.label : "Request Visit for School Trip"}
            </li>
            <li className="" onClick={() => window.open('https://www.ajmansewerage.ae/home/Bird-Watching')}>
              {General?.codeLabels["cm_request_visit_for_bird_watching"]?.label !== undefined ? General?.codeLabels["cm_request_visit_for_bird_watching"]?.label : "Request Visit for Bird Watching"}
            </li>
          </ul>
          {/* <ul>
            <li onClick={() => window.open("https://www.ajmansewerage.ae/home/ourservices/faq")}>{General?.codeLabels["cm_faqs"]?.label !== undefined ? General?.codeLabels["cm_faqs"]?.label : "FAQs"}</li>
            <li
              onClick={() =>
                window.open("https://www.ajmansewerage.ae/home/ourservices/customerhappinesscenter")
              }
            >
              {General?.codeLabels["cm_mob_location"]?.label !== undefined ? General?.codeLabels["cm_mob_location"]?.label : "Locations"}
            </li>
          </ul> */}
        </div>

        <div className="mobile-links">
          <ul>
            <li className="pb-3" onClick={() => window.open("https://www.ajmansewerage.ae/home/disclaimer")}>{General?.codeLabels["cm_disclaimer"]?.label}</li>
            <li className="pb-3">
              {General?.codeLabels["cm_website_policy"]?.label !== undefined ? General?.codeLabels["cm_website_policy"]?.label : "Website Policy"}
            </li>
            <li className="pb-3"
              onClick={() =>
                window.open("https://www.ajmansewerage.ae/home/ourservices/customerhappinesscharter")
              }
            >
              {General?.codeLabels["cm_customercharterfooter"]?.label !== undefined ? General?.codeLabels["cm_customercharterfooter"]?.label : "Happiness Chartertarted"}
            </li>
            <li onClick={() => window.open('https://www.ajmansewerage.ae/home/ASPCL-Careers')}>
              {General?.codeLabels["cm_aspcl_careers"]?.label !== undefined ? General?.codeLabels["cm_aspcl_careers"]?.label : "ASPCL Careers"}
            </li>
          </ul>
          <ul>
            <li onClick={() => window.open('https://www.ajmansewerage.ae/home/school-trip')} className="pb-3">
              {General?.codeLabels["cm_request_visit_for_school_trip"]?.label !== undefined ? General?.codeLabels["cm_request_visit_for_school_trip"]?.label : "Request Visit for School Trip"}
            </li>
            <li onClick={() => window.open('https://www.ajmansewerage.ae/home/Bird-Watching')} className="pb-3">
              {General?.codeLabels["cm_request_visit_for_bird_watching"]?.label !== undefined ? General?.codeLabels["cm_request_visit_for_bird_watching"]?.label : "Request Visit for Bird Watching"}
            </li>
            <li className="pb-3" onClick={() => window.open("https://www.ajmansewerage.ae/home/ourservices/faq")}>
              {General?.codeLabels["cm_faqs"]?.label !== undefined ? General?.codeLabels["cm_faqs"]?.label : "FAQs"}
            </li>
            <li
              onClick={() =>
                window.open("https://www.ajmansewerage.ae/home/ourservices/customerhappinesscenter")
              }
            >
              {General?.codeLabels["cm_mob_location"]?.label !== undefined ? General?.codeLabels["cm_mob_location"]?.label : "Locations"}

            </li>
          </ul>
        </div>

        <div className="social-links-wrapper">
          <div className="follow-us">
            <div className="title ">
              {General?.codeLabels["cm_follow_us_on"]?.label !== undefined ? General?.codeLabels["cm_follow_us_on"]?.label : "Follow Us On"}
            </div>

            <div className="social-links">
              <div className="fb-btn">
                <img
                  src={facebook_new}
                  style={{ cursor: "pointer", width: '30px', height: '35px'}}
                  onClick={() =>
                    window.open(
                      "https://www.facebook.com/AjmanSewerage/",
                      "_blank"
                    )
                  } alt="facebook"
                />
              </div>
              <div className="twitter-btn">
                <img
                  src={twitter_new}
                  style={{ cursor: "pointer", width: '30px', height: '35px' }}
                  onClick={() =>
                    window.open("https://twitter.com/ajman_sewerage", "_blank")
                  }
                  alt="twitter"
                />
              </div>
              <div className="instagram-btn">
                <img src={instagram_new} style={{ cursor: "pointer", width: '30px', height: '35px' }} onClick={() =>
                  window.open("https://www.instagram.com/ajmansewerage/", "_blank")
                } alt="instagram" 
                />
              </div>
              <div className="linkedin-btn">
                <img
                  src={linkedin_new}
                  style={{ cursor: "pointer", width: '30px', height: '35px' }}
                  onClick={() =>
                    window.open(
                      "https://www.linkedin.com/company/ajmansewerage/",
                      "_blank"
                    )
                  } alt="linkedin"
                />
              </div>
              <div className="youtube-btn">
                <img
                  src={youtube_new}
                  style={{ cursor: "pointer", width: '30px', height: '35px' }}
                  onClick={() =>
                    window.open(
                      "https://www.youtube.com/@ajmansewerage1338",
                      "_blank"
                    )
                  } alt="youtube"
                />
              </div>
            </div>
          </div>

          <div className="download-links w-100">
            <div style={{display:'flex',justifyContent:General?.isLargeScreen?'flex-start':"center",marginRight:General?.isLargeScreen?'':'2rem'}}>
              {General?.codeLabels["cm_footer_smart_app"]?.label !== undefined ? General?.codeLabels["cm_footer_smart_app"]?.label : "Our Smart App"}
            </div>
            <div className="d-links">
              <img
                src={appStoreNew}
                style={{ cursor: "pointer" , width:"" }}
                onClick={() =>
                  window.open(
                    "https://apps.apple.com/ae/app/ajman-sewerage-jman-llsrf/id1158776017",
                    "_blank"
                  )
                } alt="appstore"
              />
              <img
                src={googlePlayNew}
                style={{ cursor: "pointer" , width:"" }}
                onClick={() =>
                  window.open(
                    "https://play.google.com/store/apps/details?id=com.moalajah.ajmansewerageutility&pli=1",
                    "_blank"
                  )
                } alt="playstore"
              />
            </div>
          </div>
        </div>
      </div>
      
     <div
  style={{
    color: contrast?.contrastColor || "",
    backgroundColor:
      contrast?.contrastBackground || ColorAss || "#101E8E",
  }}
  className="sub-footer"
>
  <hr />

  <div className="sub-footer-content">
    {/* LEFT SIDE */}
    <div className="footer-left">
      <div>
        {General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode ==
        "ARA"
          ? `© ${getDynamicYear()} عجمان للصرف الصحى- جميع الحقوق محفوظة.`
          : General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode ==
            "HI"
          ? `© ${getDynamicYear()} अजमान सीवरेज। सर्वाधिकार सुरक्षित।`
          : `© ${getDynamicYear()} Ajman Sewerage. All rights reserved.`}
      </div>

      <div>
        {General?.codeLabels["cm_footer_browser_notice"]?.label}
      </div>

      <div>
        {General?.codeLabels["cm_last_update"]?.label ||
          "Last Updated Date :"}{" "}
        : {modifiedDate}
      </div>
    </div>

    {/* RIGHT SIDE */}
    <div className="footer-right">
      <img src={visa} alt="visa" />
      <img src={mastercard} alt="mastercard" />
      <img src={applepay} alt="applepay" />
      <img src={samsungpay} alt="samsungpay" />
      <img src={googlepay} alt="gpay" />
      <img src={tabby} alt="tabby" />
      <img src={tamara} alt="tamara" />
    </div>
  </div>
</div>

    </div>
  );
};

export default observer(Footer);
